<template>
  <!-- 時間外コンポーネント(子) -->
  <div id="overtime">
    <p style="margin-bottom: 3px; width: 60px; text-align:center;">
      <span>{{ overTimeResult[index] }}</span>
      <input type="hidden" :value="overTime" />
    </p>
  </div>
</template>

<script>
import moment from "moment";
import ConstList from './../ConstList';
export default {
  name: "OverTime",
    props: {
    dailyWorkResult: {
      type: Array,
      required: true
    },
    attendance1: Array,
    attendance2: Array,
    workTimeUnit: Array,
    workBasic: Array,
    index: Number,
  },
computed: {
  overTimeResult() {
    return this.dailyWorkResult.map((workTime, i) => {
      if (!workTime) return null;

      const basicWork = moment.duration(this.workBasic[i], "HH:mm"); // 基本労働時間
      const actualWork = moment.duration(workTime, "HH:mm");
      
      const att1 = this.attendance1[i];
      if (att1 === ConstList.HOLIDAY) {
        // 休日は「残業の事実」をそのまま表示（丸め無し・ボーナス加算無し）
        return this.formatDurationToHHMM(actualWork);
      }
      // 残業がない場合
      const diff = actualWork.subtract(basicWork);
      if (diff.asMinutes() <= 0) {
        return "";
      }

      // 残業時間を最小単位で切り上げ
      const unit = moment.duration(this.workTimeUnit[i] ?? "00:00", "HH:mm");
      const unitMinutes = unit.asMinutes();
      const roundedMinutes = Math.ceil(diff.asMinutes() / unitMinutes) * unitMinutes;

      const rounded = moment.duration(roundedMinutes, "minutes");
      return this.formatDurationToHHMM(rounded);
    });
    }
  },
  methods: {
    formatDurationToHHMM(duration) {
      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
    }
  },
  watch: {
    dailyWorkResult: {
      immediate: true,
      handler() {
        this.$emit('updateOverTime', {
          index: this.index,
          value: this.overTimeResult[this.index]
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}
</style>
